import styles from "./ImagePreviewAddOn.module.css";
import FixaImage from "@coworker/apprestructured/src/shared/wrappers/FixaImage/FixaImage";
import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import {
  isLoading,
  Loading,
} from "@coworker/apprestructured/src/task-management/loading";
import { FixaSkeleton } from "@coworker/apprestructured/src/shared/wrappers/FixaSkeleton/FixaSkeleton";

type ImagePreviewAddOnProps = {
  srcs: string[] | Loading;
};

function ImagePreviewAddOn({ srcs }: ImagePreviewAddOnProps) {
  return (
    <div className={styles["imagePreviewContainer"]}>
      {isLoading(srcs) ? (
        <>
          <FixaSkeleton width="50px" height="50px" />
          <FixaSkeleton width="50px" height="50px" />
          <FixaSkeleton width="50px" height="50px" />
        </>
      ) : (
        srcs
          .slice(0, 3)
          .map((src, i) => (
            <FixaImage className={styles["image"]!} key={i} src={src} />
          ))
      )}
      {!isLoading(srcs) && srcs.length > 3 && (
        <FixaText className={styles["moreImages"]}>+{srcs.length - 3}</FixaText>
      )}
    </div>
  );
}

export default ImagePreviewAddOn;
